import React, { useContext, useEffect, useState } from "react";
import BienvenidoAdmin from "../../components/administracion/BienvenidoAdmin";
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";
import { DarkModeContext } from "../../context/DarkModeContext";
import TablaLeadsMeta from "../../components/administracion/TablaLeadsMeta";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth";


const AdminLeadsMeta = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const verificarToken = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const response = await fetch(process.env.REACT_APP_API_TOKEN, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (!response.ok) navegacion("/");
            } catch {
                navegacion("/");
            } finally {
                setCargando(false);
            }
        };
        verificarToken();
    }, [navegacion]);

    if (cargando) return null;

    return (
        <div className={darkMode ? "bg-dark text-white min-vh-100" : "bg-light min-vh-100"}>
            <BienvenidoAdmin />
            <TituloPagina title="Leads Meta" />
            <div className="container-fluid py-4 px-4">
                <h5 className="mb-4 fw-bold">Leads de Facebook / Instagram</h5>
                <TablaLeadsMeta />
            </div>
            <Footer />
        </div>
    );
};

export default AdminLeadsMeta;
